import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.96788 2.5H9.16667V7.5H2.5V5.96788C2.49999 5.5286 2.49997 5.14961 2.52548 4.83748C2.55239 4.50802 2.61182 4.18034 2.77249 3.86503C3.01217 3.39462 3.39462 3.01217 3.86503 2.77249C4.18034 2.61182 4.50802 2.55239 4.83748 2.52548C5.14961 2.49997 5.52861 2.49999 5.96788 2.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.5 9.16667V14.0321C2.49999 14.4714 2.49997 14.8504 2.52548 15.1625C2.55239 15.492 2.61182 15.8197 2.77249 16.135C3.01217 16.6054 3.39462 16.9878 3.86503 17.2275C4.18034 17.3882 4.50802 17.4476 4.83748 17.4745C5.14962 17.5 5.52858 17.5 5.96786 17.5L9.16667 17.5V9.16667H2.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.8333 17.5L14.0321 17.5C14.4714 17.5 14.8504 17.5 15.1625 17.4745C15.492 17.4476 15.8197 17.3882 16.135 17.2275C16.6054 16.9878 16.9878 16.6054 17.2275 16.135C17.3882 15.8197 17.4476 15.492 17.4745 15.1625C17.5 14.8504 17.5 14.4714 17.5 14.0321L17.5 12.5H10.8333V17.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.5 10.8333L17.5 5.96786C17.5 5.52858 17.5 5.14962 17.4745 4.83748C17.4476 4.50802 17.3882 4.18034 17.2275 3.86503C16.9878 3.39462 16.6054 3.01217 16.135 2.77249C15.8197 2.61182 15.492 2.55239 15.1625 2.52548C14.8504 2.49997 14.4714 2.49999 14.0322 2.5H10.8333V10.8333H17.5Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }